import { Component } from '@theme/component';

export class ArticleFilterButtons extends Component {
    requiredRefs = ['swiper'];

    /** @type {any} */
    #slider = null;

    connectedCallback() {
        super.connectedCallback();
        this.#initSlider();
    }

  #initSlider() {
        this.#slider = new Swiper(this.refs.swiper, {
            allowTouchMove: true,
            slidesPerView: 'auto',
            spaceBetween: 20
        });
    }
}

if (!customElements.get('article-filter-buttons')) {
    customElements.define('article-filter-buttons', ArticleFilterButtons);
}
